import { render, staticRenderFns } from "./delivery_address_selector.vue?vue&type=template&id=b2fa9510"
import script from "./delivery_address_selector.vue?vue&type=script&lang=js"
export * from "./delivery_address_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports